module.exports = __webpack_public_path__ + "img/mint_logo.ac401daf.png";